import React, { Component, Suspense, lazy } from "react";
import { injectIntl } from "react-intl";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import axios from "axios";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Link, withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { withWidth } from "@material-ui/core";
import hubAPI from "../../services/hubAPI";
import Loader from "../../helpers/loader-full";
import HUBContext from "../../services/HUBContext";
import DashboardSwitch from "./components/switch";
import { Modal } from "antd";
import { ExpiredSessionIcon } from "../../common/icons";
import ContaEdenredHeader from "../../ContaEdenredHeader";
import { analyticsService } from "../../services/analytics.service";

const Sidebar = lazy(() => import("./components/Sidebar"));
const Footer = lazy(() => import("./components/Footer"));
const Breadcrumb = lazy(() => import("./components/Breadcrumb"));
const NoAuthorization = lazy(() => import("../../helpers/noAuthorization"));
const NoSuccess = lazy(() => import("../../helpers/notSuccess"));

const LOGIN_TRACKED_KEY = "login_tracked";

const getUserEmail = (user) =>
  user?.profile?.[
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
  ] ||
  user?.profile?.[
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
  ] ||
  user?.profile?.email ||
  user?.profile?.name ||
  user?.profile?.sub;

const { info } = Modal;
class Dashboard extends Component {
  state = {
    currentCompanyID: 0,
    prevContextCompanyID: 0,
    showLogOutDialog: false,
    status: "ready",

    deniedView: false,
    requestError: false,

    sideBarDeniedView: false,
    sideBarRequestError: false,
    expiredSession: false,
    canShowSessionDialog: false,
  };

  cancelSources = []; // guardará os CancelToken.sources
  pageHiding = false;

  onPageHide = () => {
    this.pageHiding = true;
  };
  safeLog = (...args) => {
    if (!this.pageHiding) console.error(...args);
  };

  // Espera token + userId + onload (com timeout de 5s)
  waitBootReady = () =>
    new Promise((resolve) => {
      const hasToken = () => !!localStorage.getItem("access_token");
      const hasUserId = () => !!localStorage.getItem("userId");
      const ready = () =>
        document.readyState === "complete" && hasToken() && hasUserId();

      if (ready()) return resolve(true);

      const onLoad = () => {
        if (ready()) resolve(true);
      };
      window.addEventListener("load", onLoad, { once: true });

      const poll = setInterval(() => {
        if (ready()) {
          clearInterval(poll);
          resolve(true);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(poll);
        resolve(true);
      }, 5000);
    });

  getCompanies = (companyID, changeUrl) => {
    this.setState({
      status: "loadingCompany",
      deniedView: false,
      requestError: false,
    });

    const src = axios.CancelToken.source();
    this.cancelSources.push(src);

    hubAPI
      .get("/api/v1/Company", { cancelToken: src.token })
      .then((response) => {
        const list = response?.data?.data ?? [];

        if (list.length === 0) {
          const identityUrl = `${process.env.REACT_APP_AUTH_URL}/Identity/Account/GoHubUserNotFound`;
          if (!this.pageHiding) window.location.href = identityUrl;
          return;
        }

        this.context.setCompanies(list);

        let selectedCompany = this.context.companies.filter(
          (x) => x.companyID === companyID,
        );

        if (selectedCompany.length > 0) {
          this.context.setCompanyID(selectedCompany[0].companyID);
          // if (!!this.props.history && changeUrl) this.props.history.push(`/app/${companyID}/dash`);
        } else {
          if (this.context.companies.length > 0) {
            this.context.setCompanyID(this.context.companies[0].companyID);
            // if (!!this.props.history) this.props.history.push(`/app/${this.context.companies[0].companyID}/dash`);
          } else {
            this.context.setCompanyID(0);
          }
        }

        this.setState({ status: "ready", canShowSessionDialog: true });
      })
      .catch((error) => {
        // ignora cancelamento (ex.: refresh/unmount)
        if (axios.isCancel?.(error)) return;

        this.setState({ status: "ready" });

        if (error?.response) {
          switch (error.response.status) {
            case 401:
            case 403:
              this.setState({ deniedView: true }, () => {
                if (!!this.props.history && !this.pageHiding)
                  this.props.history.push("/logout");
              });
              break;
            default:
              this.setState({ requestError: true });
              this.safeLog(error.response);
              break;
          }
        } else if (error?.request) {
          this.setState({ requestError: true });
          this.safeLog(error.request);
        } else {
          this.setState({ requestError: true });
          this.safeLog(error);
        }
      });
  };

  fetchUserSettings = (userId) => {
    if (!userId) return; // evita chamar com '?'

    const src = axios.CancelToken.source();
    this.cancelSources.push(src);

    hubAPI
      .get(`/api/v1/User/${encodeURIComponent(userId)}/usersettings`, {
        cancelToken: src.token,
      })
      .then((response) => {
        const storageKey = "user-settings";
        const baseObject = { tempFilters: [], hardFilters: [], settings: [] };

        let userSettings = localStorage.getItem(storageKey) || baseObject;
        if (typeof userSettings === "string") {
          try {
            userSettings = JSON.parse(userSettings);
          } catch {
            userSettings = baseObject;
          }
        }

        userSettings.hardFilters = [];
        const data = response?.data?.data || {};
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            try {
              userSettings.hardFilters.push([key, JSON.parse(data[key])]);
            } catch {
              userSettings.hardFilters.push([key, data[key]]);
            }
          }
        }

        localStorage.setItem(storageKey, JSON.stringify(userSettings));
      })
      .catch((error) => {
        if (axios.isCancel?.(error)) return;
        this.safeLog(error, "fetch user settings");
      });
  };

  getSideBarItems = (companyID) => {
    const { locale, setSideBarItems } = this.context;

    this.setState({
      status: "loadingSideBarItems",
      sideBarDeniedView: false,
      sideBarRequestError: false,
    });
    if (!companyID || companyID === 0)
      this.setState({ status: "ready" }, () => {
        if (!!setSideBarItems) setSideBarItems([]);
      });
    else {
      hubAPI
        .get(
          `/api/v1/Company/${companyID}/sidebaritem?pageSize=0&culture=${locale}`,
        )
        .then((response) => {
          this.setState({ status: "ready" }, () => {
            setSideBarItems(response.data.data);
          });
        })
        .catch((error) => {
          this.setState({ status: "ready" });
          if (error.response) {
            switch (error.response.status) {
              case 401:
              case 403:
                this.setState({ sideBarDeniedView: true }, () => {
                  //if (!!this.props.history)
                  //    this.props.history.push('/logout')
                });
                break;

              default:
                this.setState({ sideBarRequestError: true });
                console.log(error.response);
                break;
            }
          } else if (error.request) {
            this.setState({ sideBarRequestError: true });
            console.log(error.request);
          } else this.setState({ sideBarRequestError: true });

          console.log(error);
        });
    }
  };

  getKPIs = (companyID) => {
    const { locale } = this.context;
    if (!companyID) return;

    this.context.setGlobalStatus([...this.context.globalStatus, "loadingKPIs"]);
    hubAPI
      .get(`/api/v1/Dashboard/kpi?pageIndex=0&pageSize=0&culture=${locale}`)
      .then((response) => {
        this.context.setKpis(response.data.data);
        this.context.setGlobalStatus(
          this.context.globalStatus.filter((x) => x !== "loadingKPIs"),
        );
      })
      .catch((error) => {
        this.context.setKpis([]);
        this.context.setGlobalStatus(
          this.context.globalStatus.filter((x) => x !== "loadingKPIs"),
        );
        console.log(error);
      });
  };
  getFamilyTreeHierarchies = (array = [], parent = "") => {
    let familyTreeHierarchies = [];
    for (const hierarchy of array) {
      const name = hierarchy.name;
      const parentHierarchy = parent ? `${parent} > ${name}` : name;

      familyTreeHierarchies.push({
        parentHierarchy: parentHierarchy,
        hierarchyID: hierarchy.hierarchyID,
      });

      if (hierarchy.children && hierarchy.children.length > 0) {
        const childrenNames = this.getFamilyTreeHierarchies(
          hierarchy.children,
          parentHierarchy,
          familyTreeHierarchies,
        );
        familyTreeHierarchies.push(...childrenNames);
      }
    }
    return familyTreeHierarchies;
  };
  getFilters = (companyID) => {
    const { locale } = this.context;
    if (!companyID) return;

    this.context.setGlobalStatus([
      ...this.context.globalStatus,
      "loadingFilters",
    ]);

    hubAPI
      .get(`api/v1/Dashboard/filters/${companyID}?culture=${locale}`)
      .then((response) => {
        let data = response?.data;

        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch {
            data = {};
          }
        }

        if (!data || typeof data !== "object") data = {};

        const drivers = Array.isArray(data.drivers) ? data.drivers : [];
        data.drivers = drivers.map((m) => ({
          ...m,
          name: `${m?.firstName ?? ""} ${m?.lastName ?? ""}`.trim(),
        }));

        const hierarchyComplex = Array.isArray(data.hierarchyComplex)
          ? data.hierarchyComplex
          : [];
        const familyTreeHierarchies =
          this.getFamilyTreeHierarchies(hierarchyComplex) || [];
        data.familyTreeHierarchies = familyTreeHierarchies;

        const costCenters = Array.isArray(data.costCenters)
          ? data.costCenters
          : [];
        data.costCenters = costCenters.map((c) => ({
          ...c,
          parentHierarchy: familyTreeHierarchies.find(
            (f) => f.hierarchyID === c.hierarchyID,
          )?.parentHierarchy,
        }));

        /*
                    driverDocumentTypes
                    Algunos tipos de documentos tambien estan presentes como atributos del conductor en el caso de Brazil,
                    se marcan estos tipos aca mientras no se hagan los cambios en el modelo de datos directamente. Se deja
                    el fragmento de codigo siguiente para que sea transparente al momento de la asignacion directa desde el
                    modelo de datos.
                */
        const relatedAttributes = {
          cnh: "licenceNumber",
          matricula: "assetCode",
        };

        if (Array.isArray(data.driverDocumentTypes)) {
          data.driverDocumentTypes = data.driverDocumentTypes
            .filter((x) => x.driverDocumentTypeStatusID == 1)
            .map((x) => {
              if (x.hasOwnProperty("relatedAttribute")) return x;

              const normalizedName = x.name
                ?.normalize("NFD")
                .replace(/\p{Diacritic}/gu, "")
                .toLowerCase();

              if (normalizedName && relatedAttributes[normalizedName]) {
                x.relatedAttribute = relatedAttributes[normalizedName];
              }

              return x;
            });
        } else {
          data.driverDocumentTypes = [];
        }

        this.context.setFilterCatalogs(data);
        this.context.setGlobalStatus(
          this.context.globalStatus.filter((x) => x !== "loadingFilters"),
        );
      })
      .catch((error) => {
        this.context.setFilterCatalogs(null);
        this.context.setGlobalStatus(
          this.context.globalStatus.filter((x) => x !== "loadingFilters"),
        );
        console.log(error);
      });
  };

  getDashboards = (pageSize, pageIndex, companyID) => {
    const { locale } = this.context;
    if (!companyID) return;

    this.context.setGlobalStatus([
      ...this.context.globalStatus,
      "loadingDashboards",
    ]);
    hubAPI
      .get(
        `api/v1/Dashboard?pageSize=${pageSize}&pageIndex=${pageIndex}&culture=${locale}`,
      )
      .then((response) => {
        this.context.setDashboards(response.data.data);
        this.context.setGlobalStatus(
          this.context.globalStatus.filter((x) => x !== "loadingDashboards"),
        );
      })
      .catch((error) => {
        this.context.setDashboards(null);
        this.context.setGlobalStatus(
          this.context.globalStatus.filter((x) => x !== "loadingDashboards"),
        );
        console.log(error);
      });
  };

  componentDidMount() {
    // evita logar erros enquanto a página está sendo descarregada (refresh/navegação)
    window.addEventListener("pagehide", this.onPageHide, { once: true });

    const { params } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const upgradedCompany = urlParams.get("m") === "upgradedCompany";

    const cidLocalStorage = localStorage.getItem("companyID");
    const companyID =
      params && params.cid && !isNaN(params.cid)
        ? parseInt(params.cid, 10)
        : cidLocalStorage && !isNaN(cidLocalStorage)
          ? parseInt(cidLocalStorage, 10)
          : 0;

    const changeUrl = !params || !params.cid || isNaN(params.cid);

    // mantém seu estado atual e só dispara as chamadas quando o "ambiente" estiver pronto
    this.setState(
      {
        infoUpgradedCompany: upgradedCompany
          ? this.infoUpgradedCompany()
          : null,
      },
      () => {
        // espera token + userId + onload (com timeout de 5s dentro de waitBootReady)
        this.waitBootReady().then(() => {
          const userId = localStorage.getItem("userId");
          if (userId) {
            // usersettings só se existir userId (nada de '?')
            this.fetchUserSettings(userId);
          }

          // GTM: Track login event once per session
          try {
            if (!sessionStorage.getItem(LOGIN_TRACKED_KEY)) {
              const userStr = localStorage.getItem("user");
              const user = userStr ? JSON.parse(userStr) : null;
              const email = getUserEmail(user);

              if (email) {
                analyticsService.login(email);
                sessionStorage.setItem(LOGIN_TRACKED_KEY, "true");
              }
            }
          } catch (e) {
            console.error("Analytics login tracking error:", e);
          }

          // agora sim, chama a lista de empresas
          this.getCompanies(companyID, changeUrl);
        });
      },
    );
  }

  componentWillUnmount() {
    try {
      window.removeEventListener("pagehide", this.onPageHide);
    } catch {}
    // cancela todas as requisições pendentes ao sair/refresh
    this.cancelSources.forEach((src) => src.cancel("unmount"));
    this.cancelSources = [];
  }

  componentDidUpdate(prevProps, prevState) {
    const { companyID, expiredSession } = this.context;
    const { canShowSessionDialog } = this.state;
    const { intl } = this.props;

    if (companyID && companyID !== this.state.currentCompanyID) {
      this.setState({ currentCompanyID: companyID }, () => {
        this.getSideBarItems(companyID);
        this.getKPIs(companyID);
        this.getFilters(companyID);
        this.getDashboards(0, 0, companyID);
      });
      return; // importante para não cair nas lógicas abaixo no mesmo ciclo
    }

    const fireReloadDashboards = localStorage.getItem("reloadDash") === "true";

    if (fireReloadDashboards) {
      const cid = this.state.currentCompanyID;

      if (cid) {
        this.getSideBarItems(cid);
        this.getKPIs(cid);
        this.getFilters(cid);
        this.getDashboards(0, 0, cid);
      }

      localStorage.removeItem("reloadDash");
    }

    if (
      expiredSession === true &&
      canShowSessionDialog &&
      !this.state.expiredSession
    ) {
      this.setState({ expiredSession }, () => {
        info({
          icon: null,
          title: "",
          className: "expired-session-modal",
          content: (
            <div>
              <ExpiredSessionIcon className="icon" />
              <h1>
                {intl.formatMessage({
                  id: "sessionExpired.title",
                  defaultMessage: "Expired session!",
                })}
              </h1>
              <span>
                {intl.formatMessage({
                  id: "sessionExpired.message",
                  defaultMessage: "Please login again.",
                })}
              </span>
            </div>
          ),
          okText: intl.formatMessage({
            id: "sessionExpired.ok",
            defaultMessage: "OK",
          }),
          onOk() {
            window.location.href = "/logout";
          },
        });
      });
    }
  }

  toggleLogOutDialog = () =>
    this.setState({ showLogOutDialog: !this.state.showLogOutDialog });

  infoUpgradedCompany = () => {
    Modal.success({
      content: (
        <FormattedMessage
          id="upgradedCompany"
          defaultMessage="Your company has been successfully updated"
        />
      ),
      onOk: () => {
        this.setState({ infoUpgradedCompany: null });
      },
    });
  };

  fallBack(theme) {
    return (
      <section className={`body scheme-${theme}`}>
        <section className="main">
          <div className="db-body">
            <Loader />
          </div>
        </section>
      </section>
    );
  }

  render() {
    const { children, history, match } = this.props;
    const { lockWorkArea, theme, companyID } = this.context;
    const { infoUpgradedCompany } = this.state;

    if (!!infoUpgradedCompany) return infoUpgradedCompany;

    if (this.state.status === "loadingCompany") return this.fallBack(theme);

    if (this.state.deniedView)
      return (
        <Suspense fallback={this.fallBack(theme)}>
          <NoAuthorization />
        </Suspense>
      );

    if (this.state.requestError)
      return (
        <Suspense fallback={this.fallBack(theme)}>
          <NoSuccess />
        </Suspense>
      );

    if (!companyID || companyID === 0) {
      return this.fallBack(theme);
    }

    return (
      <Suspense fallback={this.fallBack(theme)}>
        <section className={`body scheme-${theme}`}>
          <section className="main">
            <div className="wrap-abs">
              <Sidebar />

              <section className="dash-body">
                <div className="db-head">
                  <Breadcrumb
                    history={history}
                    match={match}
                    onClickLogout={this.toggleLogOutDialog}
                  />
                </div>

                <div id="over-db-body-portal"></div>
                <div className="db-body">
                  {!!lockWorkArea && <div className="expired-trial"></div>}

                  <DashboardSwitch />

                  {children}
                </div>
              </section>
            </div>
          </section>
        </section>

        {this.state.showLogOutDialog && (
          <Dialog onClose={this.toggleLogOutDialog}>
            <p>
              <FormattedMessage
                id="logout.message"
                defaultMessage="Do you wish to Logout"
              />
            </p>
            <DialogActionsBar>
              <Link
                className="k-button"
                to="#"
                onClick={this.toggleLogOutDialog}
              >
                <FormattedMessage
                  id="no"
                  defaultMessage="No"
                ></FormattedMessage>
              </Link>
              <Link
                className="k-button"
                style={{ color: "blue" }}
                to={"/logout"}
              >
                <FormattedMessage
                  id="yes"
                  defaultMessage="Yes"
                ></FormattedMessage>
              </Link>
            </DialogActionsBar>
          </Dialog>
        )}

        <Footer />

        <ContaEdenredHeader />
      </Suspense>
    );
  }
}

Dashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  width: PropTypes.string.isRequired,
};
Dashboard.contextType = HUBContext;
Dashboard = withRouter(Dashboard);
export default compose(withWidth())(injectIntl(Dashboard));
